import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup, Step, StepLabel, Stepper, Tooltip } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ShiftData from '../../../assets/data/ShiftData';
import TimezoneData from '../../../assets/data/TimezoneData';
import UserData from '../../../assets/data/UserData';
import CustomInput from './../../../components/CustomInput';
import CustomSelect from './../../../components/CustomSelect';
import CustomDateTimePicker from '../../../components/CustomDateTimeRangePicker';
import { ControlpanelCancelButton, ControlpanelPrimaryButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog } from '../../../components/StyledComponents';
import { addEventLog, getImgEvent } from '../../../axios/Eventlog/EventLogApi';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { DateTime } from "luxon";
import { useAuth } from '../../../context/AuthContext';
import { useLoading } from '../../../context/LoadingContext';
import { getListUserGroup } from '../../../axios/Group/GroupUrlApi';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { getShiftByUser } from '../../../axios/Shift/ShiftApi';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ImageIcon from '@mui/icons-material/Image';
import CustomPagination from '../CustomPagination';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DoneIcon from '@mui/icons-material/Done';
import CustomAutocomplete from '../../../components/CustomAutocomplete';

dayjs.extend(utc);
dayjs.extend(timezone);

const normalizeTime = (time) => {
   if (!time) return null;

   if (/^\d{2}:\d{2}$/.test(time)) {
      return `${time}:00`;
   }

   if (/^\d{2}:\d{2}:\d{2}$/.test(time)) {
      return time;
   }

   return null;
};

const normalizeUserOption = (user) => ({
   ...user,
   userId: user?.userId ?? user?.id,
   id: user?.id ?? user?.userId,
});

const convertUTCToCompanyTime = (utcTime, timeZone) => {
   if (!utcTime || !timeZone) return "";

   const sign = timeZone.startsWith("-") ? -1 : 1;
   const [hh, mm] = timeZone.slice(1).split(":").map(Number);
   const offsetMinutes = sign * (hh * 60 + mm);

   return dayjs
      .utc(utcTime)
      .add(offsetMinutes, "minute");
};

const AddEventFromUndefindedImage = ({ onClose, usersData, shiftsData, onRefresh, selectedDate }) => {
   const { genaralSettingDateFormat, profile, genaralSettingTimeFormat, dateTimeFormat, genaralSettingTimeZone } = useAuth();
   const [isFormValid, setIsFormValid] = useState(false);
   const { t } = useTranslation();
   const [show, hide] = useLoading();
   const [isSubmitting, setIsSubmitting] = useState(false);
   const [userGroup, setUserGroup] = useState([]);
   const MAX_REASON_LENGTH = 255;
   const [shiftsData1, setShiftsData] = useState([]);
   const [dataIMG, setDataIMG] = useState([])
   const [page, setPage] = useState(0);
   const [pageSize, setPageSize] = useState(10);
   const [rowCount, setRowCount] = useState(0);
   const [selectedImageId, setSelectedImageId] = useState(null);
   const [isImageSectionOpen, setIsImageSectionOpen] = useState(true);
   const [activeStep, setActiveStep] = useState(0);

   const steps = [t('common.select-image'), t('button.add-event')];

   const stepperSx = {
      '& .MuiStepLabel-label.Mui-active': {
         color: '#0057FF',
         fontWeight: 600,
      },
      '& .MuiStepLabel-label.Mui-completed': {
         color: '#0057FF',
         fontWeight: 600,
      },
      '& .MuiStepIcon-root.Mui-active': {
         color: '#0057FF',
      },
      '& .MuiStepIcon-root.Mui-completed': {
         color: '#0057FF',
      },
      '& .MuiStepConnector-root.Mui-active .MuiStepConnector-line, & .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': {
         borderColor: '#0057FF',
      },
   };

   const biometricTypeData = [
      { value: 'face', label: t('common.content-095') },
   ];

   const initialFormData = {
      eventType: 1,
      userName: null,
      selectDate: selectedDate,
      selectTime: DateTime.local().toFormat('HH:mm:ss'),
      timeZone: DateTime.local().toFormat("ZZ"),
      shift: shiftsData1[0]?.shiftId,
      shiftDate: new Date(),
      latitude: '',
      longitude: '',
      description: '',
      userId: null,
      user: null,
      location: '',
      biometricType: biometricTypeData[0].value,
   };
   const [formData, setFormData] = useState(initialFormData);

   function AvatarCard({
      fullName,
      time,
      imageBase64,
      eventTypeId,
      isSelected,
      onSelect
   }) {
      const localTime = dayjs.utc(time).local().format("HH:mm:ss");
      const displayName = fullName || t('common.unidentified-user');

      return (
         <div className="text-center w-full flex flex-col items-center">
            {/* IMAGE CONTAINER */}
            <div
               className={`
      relative h-32 w-32 overflow-hidden rounded-lg
      ${isSelected ? "ring-2 ring-blue-500" : ""}
      group cursor-pointer flex items-center justify-center
   `}
               onClick={onSelect}
            >
               <img
                  src={imageBase64}
                  alt={displayName}
                  className="w-full h-full object-cover transition-all duration-200"
               />

               {/* Hover dark overlay */}
               <div
                  className="
         absolute inset-0 bg-black/40 opacity-0
         group-hover:opacity-100
         transition-opacity duration-200
      "
               />

               {/* Hover border */}
               <div
                  className="
         absolute inset-0 rounded-lg
         ring-0 group-hover:ring-2 group-hover:ring-blue-500
         transition-all duration-200
         pointer-events-none
      "
               />

               {/* Selected check icon */}
               {isSelected && (
                  <div className="absolute top-2 right-2 bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center shadow-md">
                     <DoneIcon style={{ width: '16px', height: '16px' }} />
                  </div>
               )}
            </div>

            {/* NAME */}
            <Tooltip title={displayName} arrow placement="top">
               <div className="mt-2 font-semibold text-sm text-center truncate w-32">
                  {displayName}
               </div>
            </Tooltip>

            {/* TIME */}
            <div className="flex items-center justify-center gap-1 mt-1 text-sm text-gray-600 w-32">
               <span>{localTime}</span>
            </div>
         </div>
      );
   }

   const getFromToByDateWithTZ = (date, timeZone) => {
      const base = dayjs(date).utcOffset(timeZone);

      return {
         from: base.startOf("day").utc().toISOString(),
         to: base.endOf("day").utc().toISOString(),
      };
   };

   useEffect(() => {
      if (!formData.selectDate) return;

      const browserTZ = dayjs.tz.guess();
      const { from, to } = getFromToByDateWithTZ(
         formData.selectDate,
         browserTZ
      );

      const fetchData = async () => {
         const payload = {
            page: page + 1,
            record: pageSize,
            from,
            to,
            isError: true,
            langId: localStorage.getItem("i18nextLngId")
         };

         try {
            show();
            const response = await getImgEvent(payload);

            const imgList = response.data.data || [];

            const sortedImgList = [...imgList]
               .sort((a, b) => dayjs.utc(b.time).valueOf() - dayjs.utc(a.time).valueOf())
               .map((item, index) => ({
                  ...item,
                  uniqueId: `${item.time}-${index}`
               }));

            setDataIMG(sortedImgList);

            setDataIMG(sortedImgList);
            setRowCount(response.data.pagination.totalElements);
         } catch (error) {
            toast.error('Load image error');
         } finally {
            hide();
         }
      };

      fetchData();

   }, [
      formData.selectDate,  // ✅ đổi ở đây
      page,
      pageSize
   ]);

   useEffect(() => {
      const fetchData = async () => {
         const payload = {
            group: 1,
            pageNo: 1,
            recordPerPage: 50000,
            langId: localStorage.getItem("i18nextLngId")
         }
         show()
         try {
            const response = await getListUserGroup(payload);
            setUserGroup((response.data.data || []).map(normalizeUserOption));

         } catch (error) {
            if (error.response) {
               if (error.response.status !== 401) {
                  toast.error(t(error?.response.data.message));
               }
            } else {
               toast.error(t('common.network-timeout'));
            }
         } finally {
            hide()
         }
      };
      fetchData();

   }, [t]);

   useEffect(() => {
      if (!usersData?.length) return;
      setUserGroup((prev) => {
         if (prev.length > 0) return prev;
         return usersData.map(normalizeUserOption);
      });
   }, [usersData]);

   const handleCloseDialog = () => {
      setActiveStep(0);
      setSelectedImageId(null);
      onClose();
   };

   const handleNext = () => {
      if (!selectedImageId) {
         toast.error(t('common.select-image'));
         return;
      }
      setFormData(prev => ({
         ...prev,
         location: selectedImageId?.location || prev.location || profile?.location || '',
      }));
      setActiveStep(1);
   };

   const handleBack = () => {
      setActiveStep(0);
   };

   const handleInputChange = (e) => {
      const { name } = e.target;
      let { value } = e.target;

      if (name === 'description') {
         value = value.slice(0, MAX_REASON_LENGTH);
      }

      setFormData((prevData) => ({
         ...prevData,
         [name]: value,
      }));
   };

   const handleDataChange = (name, newData) => {
      setFormData((prevData) => ({
         ...prevData,
         [name]: newData,
      }));
   };

   const [useDifferentShiftDate, setUseDifferentShiftDate] = useState(false);

   const handleCheckedChange = (event) => {
      setUseDifferentShiftDate(event.target.checked);
   };



   // const userData = UserData();
   // const shiftsData = ShiftData();format(data.normalDate, 'yyyy-MM-dd'),
   const timezoneData = TimezoneData();


   const toUTCISOString = (date) => {
      if (!date) return null;
      return new Date(date).toISOString(); // ✅ UTC
   };

   const toDate = (v) => {
      if (!v) return new Date(NaN);
      if (dayjs.isDayjs(v)) return v.toDate();
      if (v instanceof Date) return v;
      return new Date(v); // fallback cho string
   };

   const browserTZ = dayjs.tz.guess();

   const buildAttendanceDateTimeUTC = (date, time) => {
      if (!date || !time || !genaralSettingTimeZone) return null;

      // yyyy-MM-dd theo ngày chọn
      const yyyyMMdd = format(date, "yyyy-MM-dd");

      // Tạo datetime theo timezone công ty
      const companyDateTime = dayjs.tz(
         `${yyyyMMdd} ${time}`,
         "YYYY-MM-DD HH:mm:ss",
         browserTZ
      );

      // Convert về UTC ISO string
      return companyDateTime.utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
   };
   useEffect(() => {
      if (!formData.userId || !formData.selectDate || !formData.selectTime) return;

      const fetchShift = async () => {
         try {
            show();

            const dateTimeUTC = buildAttendanceDateTimeUTC(
               formData.selectDate,
               formData.selectTime
            );

            const payload = {
               userId: formData.userId,        // ✅ user đang chọn
               dateTime: dateTimeUTC,          // ✅ ISO8601 UTC (+0)
               langId: localStorage.getItem("i18nextLngId"),
            };

            const response = await getShiftByUser(payload);
            setShiftsData(response.data.data || []);
         } catch (error) {
            toast.error(t(error?.response?.data));
         } finally {
            hide();
         }
      };

      fetchShift();
   }, [
      formData.userId,
      formData.selectDate,
      formData.selectTime
   ]);

   const handleSubmitAddEventLog = async () => {

      const attendanceDateTime = buildAttendanceDateTimeUTC(
         formData.selectDate,
         formData.selectTime,
      );

      const payload = {
         ...formData,
         useDifferentShiftDate,

         // ❌ không cần gửi selectDate nữa nếu BE không dùng
         // selectDate: toUTCISOString(toDate(formData.selectDate)),

         attendanceDateTime, // ✅ ĐÚNG

         shiftDate: format(formData.shiftDate, 'yyyy-MM-dd'),
         langId: localStorage.getItem("i18nextLngId"),
         fileUUID: selectedImageId.fileUUID,
         imageEventLogId: selectedImageId.id
      };

      setIsSubmitting(true);
      try {
         const response = await addEventLog(payload);

         if (response?.data?.responseCode === 0) {
            handleCloseDialog();
            toast.success(t('common.add-event-log-successfully'));
            onRefresh();
         } else {
            toast.error(response?.data?.message);
         }
      } catch (error) {
         let jsonMatch = error.response?.data?.message?.match(/{.*}/);
         if (jsonMatch) {
            toast.error(JSON.parse(jsonMatch[0]).message);
         }
      } finally {
         setIsSubmitting(false);
      }
   };


   useEffect(() => {
      const isValid = !!formData.eventType &&
         formData.userId &&
         formData.userName &&
         formData.timeZone &&
         formData.shift &&
         !!selectedImageId;
      setIsFormValid(isValid);
   }, [formData, selectedImageId]);

   const sortedShifts = [...shiftsData1].sort((a, b) => b.shiftId - a.shiftId);

   const imageRows = React.useMemo(() => {
      return dataIMG.map((item, index) => ({
         ...item,
         id: `${item.time}-${index}`, // 👈 unique id
      }));
   }, [dataIMG]);

   useEffect(() => {
      if (sortedShifts.length > 0) {
         setFormData(prev => ({
            ...prev,
            shift: sortedShifts[0]?.shiftId
         }));
      }
   }, [shiftsData1]);

   return (
      <CustomDialog open transitionDuration={300} maxWidth={'xl'} loading={isSubmitting} onClose={handleCloseDialog} keepMounted>
         <DialogTitle>
            <div className='flex justify-between'>
               <div className='flex items-center gap-4'>
                  <p className='text-xl font-semibold '>{t('button.add-undefined-image')}</p>
               </div>
               <GrayIconButton onClick={handleCloseDialog} disabled={isSubmitting}>
                  <CloseIcon />
               </GrayIconButton>
            </div>
         </DialogTitle>
         <DialogContent>
            <div className="mt-6 mb-6">
               <Stepper activeStep={activeStep} alternativeLabel sx={stepperSx}>
                  {steps.map((label) => (
                     <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                     </Step>
                  ))}
               </Stepper>
            </div>

            {activeStep === 0 && (
               <div className="pt-4 space-y-3">
                  <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                     <div className="space-y-2">
                        <label>{t('common.date')}</label>
                        <CustomDateTimePicker
                           mode="singleTime"
                           className="h-10"
                           showOnlyDate
                           disableTime
                           value={
                              formData.selectDate && formData.selectTime
                                 ? dayjs(
                                    `${dayjs(formData.selectDate).format('YYYY-MM-DD')} ${normalizeTime(formData.selectTime) || formData.selectTime}`
                                 ).toDate()
                                 : formData.selectDate || null
                           }
                           dateTimeFormat={dateTimeFormat}
                           onChange={(newDateTime) => {
                              const d = dayjs(newDateTime);
                              setFormData((prev) => ({
                                 ...prev,
                                 selectDate: d.toDate(),
                                 selectTime: d.format('HH:mm:ss'),
                              }));
                           }}
                        />
                     </div>

                     <div className="space-y-2">
                        <label>{t('common.content-094')}</label>
                        <CustomSelect
                           name="biometricType"
                           value={formData.biometricType}
                           onChange={handleInputChange}
                           options={biometricTypeData}
                        />
                     </div>
                  </div>

                  <div className="pt-2">
                     <div className="flex items-center justify-between mb-3 bg-[#F5F8FF] rounded-md p-3 border-l-[5px] border-[#0057FF]">
                        <p className="font-semibold">{t('common.event-images')}</p>
                        <button
                           type="button"
                           onClick={() => setIsImageSectionOpen((prev) => !prev)}
                           className="text-sm font-medium hover:underline"
                        >
                           {isImageSectionOpen ? (
                              <ExpandMoreIcon sx={{ fontSize: 18 }} />
                           ) : (
                              <ExpandLessIcon sx={{ fontSize: 18 }} />
                           )}
                        </button>
                     </div>

                     <div>
                        {isImageSectionOpen && (
                           <>
                              {dataIMG?.length === 0 ? (
                                 <div className="flex flex-col justify-center items-center h-[200px] gap-2 text-gray-400">
                                    <ImageIcon style={{ height: 45, width: 45 }} />
                                    {t('common.no-image')}
                                 </div>
                              ) : (
                                 <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                                    {dataIMG.map((item) => {
                                       const isSelected = selectedImageId?.uniqueId === item.uniqueId;

                                       return (
                                          <div key={item.uniqueId}>
                                             <AvatarCard
                                                {...item}
                                                isSelected={isSelected}
                                                onSelect={() =>
                                                   setSelectedImageId((prev) =>
                                                      prev?.uniqueId === item.uniqueId ? null : item
                                                   )
                                                }
                                             />
                                          </div>
                                       );
                                    })}
                                 </div>
                              )}

                              <div className="flex justify-center mt-4 w-full">
                                 <CustomPagination
                                    page={page}
                                    count={rowCount}
                                    rowsPerPage={pageSize}
                                    onPageChange={(newPage) => {
                                       document.activeElement?.blur();
                                       setPage(newPage);
                                    }}
                                    onRowsPerPageChange={(newPageSize) => {
                                       const size =
                                          typeof newPageSize === "number"
                                             ? newPageSize
                                             : parseInt(newPageSize, 10);
                                       setPage((prevPage) => {
                                          const firstRowIndex = prevPage * pageSize;
                                          const newPage = Math.floor(firstRowIndex / size);
                                          const maxPage = Math.max(0, Math.ceil(rowCount / size) - 1);
                                          return Math.min(newPage, maxPage);
                                       });
                                       setPageSize(size);
                                    }}
                                 />
                              </div>
                           </>
                        )}
                     </div>
                  </div>
               </div>
            )}

            {activeStep === 1 && (
               <>
                  {selectedImageId?.imageBase64 && (
                     <div className="flex items-start justify-center gap-3 mb-4">
                        <div className="flex items-center justify-center overflow-hidden border border-gray-200 p-[5px] rounded-[4px]">
                           <img
                              src={selectedImageId.imageBase64}
                              alt="preview"
                              className="w-[168px] h-[170px] object-cover rounded-[4px]"
                           />
                        </div>
                     </div>
                  )}

                  <div className='pt-3'>
                     <p>{t('common.event-type')}<span className='text-[#EF4444] ml-1'>*</span></p>
                     <FormControl
                        component='fieldset'
                        sx={{
                           '.MuiFormGroup-root.MuiFormGroup-row': {
                              gap: '20px',
                           },
                        }}
                     >
                        <RadioGroup row aria-label='Event type' name='eventType' value={formData.eventType} onChange={handleInputChange}>
                           <FormControlLabel value={1} control={<Radio size='small' />} label={t('attendance.CHECK_IN')} />
                           <FormControlLabel value={2} control={<Radio size='small' />} label={t('attendance.CHECK_OUT')} />
                        </RadioGroup>
                     </FormControl>
                  </div>
                  <div className='grid grid-cols-12 md:gap-x-10 gap-y-6'>
                     <div className='col-span-12 md:col-span-6 mt-2'>
                        <label className='mb-2.5'>
                           {t('common.user-name')}<span className='text-[#EF4444] ml-1'>*</span>
                        </label>
                        <CustomAutocomplete
                           className='min-w-60 !mt-2'
                           name='userName'
                           value={formData.user}
                           onDataChange={(name, value) => {
                              if (!value || typeof value === 'string') {
                                 setFormData(prev => ({
                                    ...prev,
                                    user: null,
                                    userName: null,
                                    userId: null,
                                    location: '',
                                 }));
                                 return;
                              }

                              const normalizedUser = normalizeUserOption(value);
                              setFormData(prev => ({
                                 ...prev,
                                 user: normalizedUser,
                                 userName: normalizedUser.fullName || '',
                                 userId: normalizedUser.userId ?? null,
                                 location: normalizedUser.location || prev.location || '',
                              }));
                           }}
                           options={userGroup}
                           dataType='user'
                           freeSolo={true}
                           placeholder={t('common.content-161')}
                        />

                     </div>
                     <div className='col-span-12 md:col-span-6 mt-2'>
                        <label>{t('common.date-time')}</label><span className='text-[#EF4444] ml-1'>*</span>
                        <div className='mt-2'>
                           <CustomDateTimePicker
                              mode="singleTime"
                              value={
                                 formData.selectDate && formData.selectTime
                                    ? dayjs(
                                       `${dayjs(formData.selectDate).format('YYYY-MM-DD')} ${normalizeTime(formData.selectTime) || formData.selectTime}`
                                    ).toDate()
                                    : formData.selectDate || null
                              }
                              dateTimeFormat={dateTimeFormat}
                              onChange={(newDateTime) => {
                                 const d = dayjs(newDateTime);
                                 setFormData((prev) => ({
                                    ...prev,
                                    selectDate: d.toDate(),
                                    selectTime: d.format('HH:mm:ss'),
                                 }));
                              }}
                           />
                        </div>
                     </div>

                     <div className='col-span-12 md:col-span-12'>
                        <label>{t('common.shift')}</label><span className='text-[#EF4444] ml-1'>*</span>
                        <CustomSelect
                           name='shift'
                           value={formData.shift}
                           onChange={handleInputChange}
                           options={sortedShifts}
                           className='mt-2'
                           dataType='shift'
                        />
                     </div>

                     {/* <div className='col-span-12 md:col-span-6 flex flex-col gap-2'>
                        <label className='shrink-0 text-[#171717]'>{t('common.location')}</label>
                        <div className='w-full'>
                           <CustomInput
                              inputType='text'
                              readOnly={true}
                              value={formData.location}
                              labelEnable={false}
                           />
                        </div>
                     </div> */}

                     <div className='col-span-12'>
                        <label>{t('common.reason')}</label>
                        <CustomInput
                           name='description'
                           inputType='text'
                           value={formData.description}
                           handleInputChange={handleInputChange}
                           labelEnable={false}
                           className='mt-2'
                           placeholder={t('common.reason')}
                        />

                        {/* <div
                           className={`flex justify-end text-xs mt-1 ${formData.description.length >= MAX_REASON_LENGTH
                              ? 'text-red-500'
                              : 'text-gray-500'
                              }`}
                        >
                           {formData.description.length}/{MAX_REASON_LENGTH}
                        </div> */}
                     </div>
                  </div>
               </>
            )}
         </DialogContent>
         <DialogActions>
            <div className='flex gap-2 px-4 py-4'>
               {activeStep === 0 ? (
                  <>
                     <ControlpanelCancelButton onClick={handleCloseDialog} disabled={isSubmitting}>
                        <p>{t('button.cancel')}</p>
                     </ControlpanelCancelButton>
                     <ControlpanelPrimaryButton onClick={handleNext} disabled={isSubmitting || !selectedImageId}>
                        <p>{t('button.next')}</p>
                     </ControlpanelPrimaryButton>
                  </>
               ) : (
                  <>
                     <ControlpanelCancelButton onClick={handleBack} disabled={isSubmitting}>
                        <p>{t('button.back')}</p>
                     </ControlpanelCancelButton>
                     <ControlpanelPrimaryButton onClick={handleSubmitAddEventLog} disabled={isSubmitting || !isFormValid}>
                        <AddIcon />
                        <p>{t('button.add-event')}</p>
                     </ControlpanelPrimaryButton>
                  </>
               )}
            </div>
         </DialogActions>
      </CustomDialog>
   );
};

export default AddEventFromUndefindedImage;
